/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import {
 Button,
 DatePickerField,
 KTSVG,
 Model,
} from 'helpers'
import {IFormData, IFormField} from 'models/Common'
import {useTranslation} from 'react-i18next'
import moment from 'moment'
import {formatDateForDB} from 'utils/helper'

type Props = {
 containerClass?: string
 titleClass?: string
 title?: string
 btnClass?: string
 filterFormData?: IFormField
 setFilterFormData: (formData: IFormField) => void
}

const KTDateRangeFilter: React.FC<Props> = (
 props: Props
) => {
 const {t} = useTranslation()
 const [openDatePicker, setOpenDatePicker] = useState(false)
 const [activeTab, setActiveTab] = useState('')
 const [selectedValue, setSelectedValue] = useState('')
 const rangeTypes = [
  {
   label: t('quickFilter.last7Days'),
   value: 7,
  },
  {
   label: t('quickFilter.last15Days'),
   value: 15,
  },
  {
   label: t('quickFilter.last30Days'),
   value: 30,
  },
  {
   label: t('quickFilter.last3Months'),
   value: 90,
  },
  {
   label: t('quickFilter.custom'),
   value: 0,
  },
 ]
 const {
  register,
  handleSubmit,
  control,
  watch,
  setValue,
  getValues,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...props.filterFormData},
 })

 async function submitFormData(formData: IFormField) {
  const rangeType = Number(formData?.rangeType)
  const rec = rangeTypes.filter(
   (val) => val.value === rangeType
  )
  let fromDate: Date
  let toDate: Date
  setSelectedValue(rec?.[0]?.label)
  if (rangeType > 0) {
   fromDate = moment().subtract(rangeType, 'days').toDate()
   toDate = moment().toDate()
  } else {
   fromDate = formData?.fromDate
   toDate = formData?.toDate
  }
  props.setFilterFormData((prevState: IFormField) => ({
   ...prevState,
   from_date: fromDate,
   to_date: toDate,
  }))
  setOpenDatePicker(false)
 }

 useEffect(() => {
  const rangeType = props.filterFormData?.rangeType
  if (rangeType) {
   const rec = rangeTypes.find(
    (val) => val.value === rangeType
   )
   if (rec) {
    setSelectedValue(rec.label)
    void submitFormData({
     rangeType: rec.value,
    })
    setValue('rangeType', rangeType.toString())
   }
  }
 }, [])

 useEffect(() => {
  const fromDate = props.filterFormData?.from_date
  const toDate = props.filterFormData?.to_date
  if (fromDate !== getValues('fromDate')) {
   setValue('fromDate', fromDate)
  }
  if (toDate !== getValues('toDate')) {
   setValue('toDate', toDate)
  }
 }, [props.filterFormData])

 return (
  <>
   <Model
    show={openDatePicker}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-12 h-12 !text-[#33393D]'
    header={''}
    close={() => {
     setOpenDatePicker(false)
    }}
    modelClass='md:w-[450px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <div className='w-full'>
      <p className='text-[#171B1F] text-left font-bold text-2xl'>
       {props.title}
      </p>
      <form
       method='POST'
       action=''
       onSubmit={handleSubmit(submitFormData)}
      >
       <div className='w-full mb-7 text-[#33393D] text-base font-medium'>
        {rangeTypes.map((val, key) => (
         <div
          key={key}
          className='cursor-pointer flex items-center pt-5'
         >
          <input
           type='radio'
           className={`w-5 h-5 !border-[#4E83E4]`}
           placeholder=' '
           //  defaultChecked={item[OptionValueKey] === value}
           value={val.value}
           // autoComplete={autoComplete}
           // autoFocus={autoFocus}
           {...register('rangeType')}
          />
          <span className='ml-2'>{val.label}</span>
         </div>
        ))}
        {watch('rangeType') == 0 && (
         <div className='ml-7 mt-2 flex text-blue-500 font-bold'>
          <DatePickerField
           disabled={false}
           label={t('common.fromDate')}
           required={false}
           popperClassName='!z-[50]'
           labelClassName='text-[#80868C] text-sm font-normal'
           wrapperClassName={'!max-w-[130px]'}
           inputWrapperClassName='!py-0 !px-0 !border-0 !rounded-none'
           calendarIconClassName='z-[1] !pt-[10px] left-0'
           className='relative text-sm font-normal !pl-6 !pr-1 border rounded-lg !py-2 !border-[#E6EBF0]'
           id={`fromDate`}
           name={`fromDate`}
           control={control}
           rules={{
            onChange: () => {
             //   void getDistrictData(e, `${record.key}.district`)
            },
           }}
           //   minDate={watch('fromDate')}
           maxDate={moment().toDate()}
           placeholder={t('common.dateFormat')}
           errors={errors}
           dateFormat='dd-MM-yyyy'
          />
          <DatePickerField
           disabled={false}
           label={t('common.toDate')}
           required={false}
           popperClassName='!z-[50]'
           labelClassName='text-[#80868C] text-sm font-normal'
           wrapperClassName={'!max-w-[130px] ml-2'}
           inputWrapperClassName='!py-0 !px-0 !border-0 !rounded-none'
           calendarIconClassName='z-[1] !pt-[10px] left-0'
           className='relative text-sm font-normal !pl-6 !pr-1 border rounded-lg !py-2 !border-[#E6EBF0]'
           id={`toDate`}
           name={`toDate`}
           control={control}
           rules={{
            onChange: () => {
             //   void getDistrictData(e, `${record.key}.district`)
            },
           }}
           minDate={
            watch('fromDate')
             ? watch('fromDate')
             : undefined
           }
           maxDate={moment().toDate()}
           placeholder={t('common.dateFormat')}
           errors={errors}
           dateFormat='dd-MM-yyyy'
          />
         </div>
        )}
       </div>
       <div className='md:flex items-center justify-center'>
        <Button
         type={'submit'}
         color='blue'
         className='text-center w-full py-[9px] px-[24px] bg-[#4E83E4] 
                            !rounded-lg !text-sm text-white font-semibold'
        >
         {t('common.next')}
        </Button>
       </div>
      </form>
     </div>
    </div>
   </Model>
   <div
    className={`${props?.containerClass} flex justify-center items-center text-base`}
   >
    <div
     className={`${props?.titleClass} text-[#33393D] font-medium text-sm ml-2`}
    >
     {props.title}
    </div>
    <div
     onClick={() => {
      setOpenDatePicker(true)
     }}
     className={`${props.btnClass} w-[180px] h-[44px] text-[#33393D] text-sm font-normal border-[#CED8E0] bg-white border rounded-lg flex justify-between items-center text-base font-medium p-2 ml-2 cursor-pointer`}
    >
     <span className=''>{selectedValue}</span>
     <span className='fa fa-chevron-down font-normal text-xs' />
    </div>
   </div>
  </>
 )
}

export {KTDateRangeFilter}
